var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"domain"},_vm._l((_vm.ticks),function(tick){return _c('div',{staticClass:"tick",style:({left: tick.position + 'px'})},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(tick.value))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b4a391","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/XAxis.vue
// module id = 240
// module chunks = 1